import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { CloudUpload, Close } from "@mui/icons-material";
import apiEndpoints from "../../apiconfig";

const photoKeys = [
  "profile_photo",
  "profile_photo1",
  "profile_photo2",
  "profile_photo3",
];

const UploadPhotos = ({
  form,
  handleMultiImageUpload,
  removePhotoAt,
  showErrors,
}) => {
  // Helper function to get the image URL regardless of format
  const getImageUrl = (imageData) => {
    if (!imageData) return null;
    if (typeof imageData === "string") return imageData; // API returns string URL
    if (typeof imageData === "object" && imageData.url) return imageData.url; // New upload
    return null;
  };

  // Helper function to get the image name
  const getImageName = (imageData, key) => {
    if (!imageData) return "";
    if (typeof imageData === "string")
      return `Existing ${key.replace("_", " ")}`;
    if (typeof imageData === "object" && imageData.name) return imageData.name;
    return "Unknown";
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Upload Photos (Max 4, JPG/PNG)
      </Typography>

      {showErrors &&
        !form.profile_photo &&
        !form.profile_photo1 &&
        !form.profile_photo2 &&
        !form.profile_photo3 && (
          <Typography color="error" variant="body2" sx={{ mb: 2 }}>
            At least one photo is required
          </Typography>
        )}

      {/* Single upload button */}
      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => document.getElementById("photos-input")?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose photos</Typography>
          <input
            id="photos-input"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            multiple
            style={{ display: "none" }}
            onChange={handleMultiImageUpload}
          />
        </CardContent>
      </Card>

      {/* Preview selected photos */}
      <Grid container spacing={2}>
        {photoKeys.map((key, idx) => {
          const imageUrl = getImageUrl(form[key]);
          if (!imageUrl) return null;

          return (
            <Grid item xs={6} sm={3} key={key}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 1,
                  overflow: "hidden",
                }}
              >
                <img
                  src={
                    typeof form[key] === "object"
                      ? imageUrl
                      : `${apiEndpoints.image}${imageUrl}`
                  }
                  alt={getImageName(form[key], key)}
                  style={{ width: "100%", height: 120, objectFit: "cover" }}
                />
                <IconButton
                  size="small"
                  onClick={() => removePhotoAt(idx)}
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    bgcolor: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </Box>
              {/* <Typography
                variant="caption"
                sx={{ display: "block", mt: 0.5 }}
                noWrap
              >
                {getImageName(form[key], key)}
              </Typography> */}
            </Grid>
          );
        })}
      </Grid>

      <Typography variant="body2" sx={{ mt: 1 }}>
        Uploaded: {photoKeys.filter((k) => getImageUrl(form[k])).length}/4
      </Typography>
    </Box>
  );
};

export default UploadPhotos;
